import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import VueSanitize from 'vue-sanitize-directive';
import App from './App.vue';
import DialogPlugin from './plugins/DialogPlugin';
import router from './router';
import store from './store';
import ExternalPagePlugin from './plugins/ExternalPagePlugin';

Vue.config.productionTip = false;

Vue.use(VueSanitize);

Sentry.init({
  Vue,
  dsn:
    'https://742ddbbdb07847bc926df0bad4800195@o442056.ingest.sentry.io/5619753',
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.2,
  logErrors: true,
  environment: process.env.VUE_APP_ENVIRONMENT,
});

Vue.use(DialogPlugin);

Vue.use(ExternalPagePlugin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
